import React from "react";
import { PiStudent } from "react-icons/pi";
import { FaQuoteRight } from "react-icons/fa";

const OurTestimonials = () => {
  const testimonials = [
    {
      text: "The teacher would sit in front of us and teach through Google meet. He would type code and all the students would just copy it or do nothing just watch the class. I found this type of teaching very amature considering the amount I paid for.",
      name: "Sraddhananda Rath",
      aos: "zoom-in-left",
    },
    {
      text: "The UI/UX design course exceeded my expectations. The instructor's expertise and practical assignments helped me improve my design skills. I feel more confident in my career now. Thank you!",
      name: "Pratyush Nayak",
      aos: "zoom-in-right",
    },
    {
      text: "WebBocket delivers excellent project guidance tailored to our needs. Their expert team ensures success from start to finish. Highly recommended.",
      name: "Jyotipriya Jena",
      aos: "zoom-out",
    },
    {
      text: "The web developer training provided a solid foundation, blending theory with practical exercises, equipping me with the tools to excel in the field.",
      name: "Deepak Kumar Mahanta",
      aos: "zoom-out-up",
    },
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      {/* soft glows similar to other sections */}
      <div className="pointer-events-none absolute top-1/3 -left-32 h-80 w-80 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -right-32 h-96 w-96 rounded-full bg-[#5989C8]/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-14">
        {/* Heading */}
        <div className="mb-8 md:mb-10">
          <p
            className="text-[10px] text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#064585]"
            data-aos="fade-up"
          >
            Feedback
          </p>
          <h2
            className="mt-3 text-3xl md:text-4xl lg:text-5xl font-semibold text-slate-900"
            data-aos="zoom-out-right"
          >
            Our{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
              Testimonials
            </span>
          </h2>
          <p
            className="text-slate-600 mt-4 md:max-w-[60%] tracking-wide text-sm sm:text-base md:text-lg"
            data-aos="zoom-out-left"
          >
            Discover what our learners say about us. Real stories highlighting
            our dedication, quality training, and impact. Each testimonial shows
            how we help students grow with confidence.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mt-6">
          {testimonials.map((t, index) => (
            <TestimonialCard
              key={index}
              text={t.text}
              name={t.name}
              aos={t.aos}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTestimonials;

function TestimonialCard({ text, name, image, quoteColor, aos }) {
  const colorClasses =
    quoteColor === "blue"
      ? "bg-[#e1ecff] border-[#5989C8]/40"
      : "bg-slate-100 border-slate-200";

  return (
    <div
      className="bg-white/80 backdrop-blur rounded-2xl shadow-md border border-[#5989C8] p-6 md:p-7 flex flex-col h-full"
      data-aos={aos}
    >
      {/* top quote icon */}

      <p className="text-slate-800 text-sm sm:text-base leading-relaxed flex-1">
        {text}
      </p>

      <div className="flex items-center mt-5 justify-between">
        <div className="flex gap-1 items-center">
          <PiStudent
            size={25}
            className="text-[#064585] h-10 w-10 p-2 rounded-full bg-[#e1ecff]"
          />
          <p className="text-slate-900 font-semibold text-sm sm:text-base">
            {name}
          </p>
        </div>

        <div
          className={`inline-flex items-center justify-center w-10 h-10 rounded-full border ${colorClasses} mb-4`}
        >
          <FaQuoteRight
            size={20}
            className="text-[#064585] h-10 w-10 p-2 rounded-full bg-[#e1ecff]"
          />
        </div>
      </div>
    </div>
  );
}
